var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isCpfValid } from "../ValidationUtils";
import { isValidCpf, normalizeCpf } from '../documentoValidators';
import { defaultMessageFieldCpfError, defaultMessageFieldError } from '../../Requerimento/Cadastro/context/RequerimentoContext';
export var handleValidCpfForm = function (_a) {
    var _b, _c, _d, _e;
    var _f;
    var event = _a.event, onChange = _a.onChange, formData = _a.formData, fieldsErrors = _a.fieldsErrors, fieldErrorChange = _a.fieldErrorChange, setCpfValid = _a.setCpfValid, _g = _a.fieldError, fieldError = _g === void 0 ? "cpfError" : _g;
    var cpf = (_f = event === null || event === void 0 ? void 0 : event.target) === null || _f === void 0 ? void 0 : _f.value;
    var _cpf = normalizeCpf(cpf);
    onChange(__assign(__assign({}, formData), { cpf: _cpf }));
    if (cpf.trim() === '') {
        fieldErrorChange(__assign(__assign({}, fieldsErrors), (_b = {}, _b["".concat(fieldError)] = defaultMessageFieldError, _b)));
        return false;
    }
    var valid = cpf && isCpfValid(cpf);
    if (!valid) {
        fieldErrorChange(__assign(__assign({}, fieldsErrors), (_c = {}, _c["".concat(fieldError)] = "".concat(defaultMessageFieldCpfError, ". Deve conter 11 d\u00EDgitos."), _c)));
        setCpfValid === null || setCpfValid === void 0 ? void 0 : setCpfValid(false);
        return false;
    }
    if (!isValidCpf(cpf)) {
        fieldErrorChange(__assign(__assign({}, fieldsErrors), (_d = {}, _d["".concat(fieldError)] = defaultMessageFieldCpfError, _d)));
        setCpfValid === null || setCpfValid === void 0 ? void 0 : setCpfValid(false);
        return false;
    }
    fieldErrorChange(__assign(__assign({}, fieldsErrors), (_e = {}, _e["".concat(fieldError)] = "", _e)));
    setCpfValid === null || setCpfValid === void 0 ? void 0 : setCpfValid(true);
    return true;
};
